<template>
  <div class="form tab-content" style="min-height: 200px">
    <v-layout style="width: 100%">
      <asset-selection
        v-if="canAddNetworkElements"
        :template="template"
        :filters="[]"
        :layers-to-show="layersToShow"
      />

      <v-divider vertical v-if="canAddNetworkElements" />

      <selected-assets
        tab="networkElements"
        :action-type="actionType"
        :asset-reservation-objects="networkElements"
        :user-can-add-objects="canAddNetworkElements"
        @update-asset-reservation-objects="
          $emit('update-network-elements', $event)
        "
        @dissociate-asset-reservation-object="
          $emit('dissociate-asset-reservation-object', $event)
        "
      />
    </v-layout>
  </div>
</template>

<script>
import MultipleObjectsMultipleLayersTable from "@/components/Home/Forms/_Organisms/MultipleObjectsMultipleLayersTable";
import AssetSelection from "@/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab/AssetSelection";
import SelectedAssets from "@/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab/SelectedAssetReservationObjects";

export default {
  name: "AssetReservationFormNetworkElementsTab",

  components: {
    SelectedAssets,
    AssetSelection,
    MultipleObjectsMultipleLayersTable
  },

  props: {
    disabled: {
      type: Boolean
    },

    actionType: {
      type: String,
      required: true
    },

    template: {
      type: Object
    },

    networkElements: {
      type: Array
    }
  },

  computed: {
    canAddNetworkElements() {
      return this.actionType === "addNetworkElementsToReservation";
    },

    layersToShow() {
      return this.$store.getters.getValidAssetReservationObjectLayersInArea;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AssetReservationForm/NetworkElementsTab.vue